import React from 'react'
import * as XLSX from 'xlsx';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';


const Jobs = ({ jobs, showApplicants, applicants, setApplicants, setShowApplicants, setJobs }) => {
    const [sortOption, setSortOption] = useState('recentlyPosted');
    const [selectedJob, setSelectedJob] = useState(null);
    const downloadToExcel = () => {
        const data = sortedJobs.map((job) => ({
            Title: job.title,
            Description: job.description,
            Category: job.category,
            'Location Type': job.locationType,
            Location: job.location,
            'Experience Level': job.experienceLevel,
            'Salary Range': job.salaryRange,
            Deadline: new Date(job.deadline).toLocaleDateString(),
            Department: job.department,
            Responsibilities: job.responsibilities,
            Requirements: job.requirements,
            'Application Link': job.applicationLink,
            'Contact Email': job.contactEmail,
            'Allow Sharing': job.allowSharing ? 'Yes' : 'No',
            Views: job.views,
            'Created At': new Date(job.createdAt).toLocaleString(),
        }));

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Jobs');
        XLSX.writeFile(workbook, 'jobs.xlsx');
    };

    const handleArchive = async (id) => {
        try {
            console.log(id);
            const token = localStorage.getItem('accessToken');
            // Make the DELETE request with the ID in the request body
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/jobs/archivejob`, {
                id: id, // Send the ID in the request body
            }, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            // If the delete request is successful, update the local state
            setJobs(jobs.filter((job) => job._id !== id)); // Assuming _id is used

            console.log('Job archived successfully on the server.');
        } catch (error) {
            console.error('Error archiving job:', error);
            // Handle the error (e.g., show an error message to the user)
        }
    };
    const handleDelete = async (id) => {
        try {
            console.log(id);
            const token = localStorage.getItem('accessToken');
            // Make the DELETE request with the ID in the request body
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/jobs/deletejob`, {
                id: id, // Send the ID in the request body
            }, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            // If the delete request is successful, update the local state
            setJobs(jobs.filter((job) => job._id !== id)); // Assuming _id is used

            console.log('Job deleted successfully on the server.');
        } catch (error) {
            console.error('Error deleting job:', error);
            // Handle the error (e.g., show an error message to the user)
        }
    };
    const fetchApplicants = async (jobId) => {
        try {
            // Always clear previous applicants before fetching new ones
            setApplicants({ ...applicants, [jobId]: [] });
            const token = localStorage.getItem('accessToken');
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/jobs/getjobapplications?id=${jobId}`,
                { headers: { 'Authorization': `Bearer ${token}` } }
            );
            console.log(response.data);
            setApplicants({ ...applicants, [jobId]: response.data });
            setShowApplicants({ ...showApplicants, [jobId]: true });
        } catch (error) {
            console.error('Error fetching applicants:', error);
        }
    };
    const sortJobs = (jobsToSort, option) => {
        let sortedJobs = [...jobsToSort]; // Create a copy

        switch (option) {
            case 'mostViews':
                sortedJobs.sort((a, b) => b.views - a.views);
                break;
            case 'leastViews':
                sortedJobs.sort((a, b) => a.views - b.views);
                break;
            case 'recentlyPosted':
                sortedJobs.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                break;
            case 'earliestPosted':
                sortedJobs.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
                break;
            case 'highestApplicants':
                sortedJobs.sort((a, b) => b.applicants - a.applicants);
                break;
            case 'leastApplicants':
                sortedJobs.sort((a, b) => a.applicants - b.applicants);
                break;
            default:
                break;
        }

        return sortedJobs;
    };
    const sortedJobs = sortJobs(jobs, sortOption);

    const downloadInsdividualJobExcel = async (job) => {
        try {
            const jobId = job._id;
            const token = localStorage.getItem('accessToken');
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/jobs/getjobapplications?id=${jobId}`,
                { headers: { 'Authorization': `Bearer ${token}` } }
            );
            console.log(response.data);
            const datatobeprintedtoexcel = response.data;

            if (!datatobeprintedtoexcel || datatobeprintedtoexcel.length === 0) {
                console.log("No data to export.");
                alert("No data to export.");
                return;
            }

            // Convert data to worksheet
            const ws = XLSX.utils.json_to_sheet(datatobeprintedtoexcel);

            // Create workbook and add worksheet
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Job Applications");

            // Generate Excel file
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const excelData = new Uint8Array(excelBuffer);

            // Create a download link
            const blob = new Blob([excelData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `JobApplications_${jobId}.xlsx`; // Set filename
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a); // Clean up
            window.URL.revokeObjectURL(url); // Clean up
        } catch (error) {
            console.error('Error fetching applicants or exporting to Excel:', error);
            alert('Error exporting to Excel. Please check the console for details.');
        }
    };

    return (
        <div className="grid grid-cols-1 gap-4">

            <h2 className="text-lg font-bold text-[#2c2c2c]">All Jobs</h2>


            <select
                value={sortOption}
                onChange={(e) => setSortOption(e.target.value)}
                className="bg-white border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring focus:border-blue-300"
            >
                <option value="recentlyPosted">Recently Posted</option>
                <option value="earliestPosted">Earliest Posted</option>
                <option value="mostViews">Most Views</option>
                <option value="leastViews">Least Views</option>
                <option value="highestApplicants">Highest Applicants</option>
                <option value="leastApplicants">Least Applicants</option>
            </select>

            <button
                onClick={downloadToExcel}
                className="bg-[#EE7828B5] text-white font-bold py-2 px-4 rounded w-fit ml-auto"
            >
                Download to Excel
            </button>
            {sortedJobs?.map((job) => (
                <div key={job._id}>
                    <div className="bg-[#fff] text-black p-4 rounded shadow">
                        <h3 className="text-lg font-bold">{job.title}</h3>
                        <p>{job.description}</p>
                        <div className="mt-4 flex gap-2">
                            <button
                                className="bg-[#ee7828] text-white px-4 py-2 rounded hover:bg-[#d86b1f]"
                                onClick={() => setSelectedJob(job)}
                            >
                                View
                            </button>
                            <button
                                className="bg-[#2c2c2c] text-white px-4 py-2 rounded hover:bg-[#1f1f1f]"
                                onClick={() => handleArchive(job._id)}
                            >
                                Pause Job
                            </button>
                            <button
                                className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
                                onClick={() => handleDelete(job._id)}
                            >
                                Delete
                            </button>
                            <button
                                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                                onClick={() => fetchApplicants(job._id)}
                            >
                                View All Applicants
                            </button>
                            <button
                                className="bg-green-500 text-white px-3 py-1 rounded text-sm"
                                onClick={() => downloadInsdividualJobExcel(job)}
                            >
                                Download to Excel
                            </button>
                        </div>
                    </div>
                    {showApplicants[job._id] && (
                        <div className="mt-2 p-4 bg-gray-100 rounded shadow">
                            {applicants[job._id]?.length > 0 ? (
                                <ul>
                                    {applicants[job._id]?.map((applicant, index) => (
                                        <li key={applicant._id} className="p-2 text-sm flex justify-between items-center">
                                            <div>
                                                <span className="font-bold mr-2">{index + 1}.</span>
                                                <span>{applicant.email}</span>
                                                <span className="text-gray-500 text-xs ml-2">
                                                    (Applied on {new Date(applicant.appliedAt).toLocaleDateString()})
                                                </span>
                                                <span className="text-gray-600 text-xs ml-2">
                                                    (Application ID: {applicant.applicationID})
                                                </span>
                                            </div>
                                            <Link to={`/viewapplication/${applicant._id}`} target='_blank'>
                                                <button className="button !rounded">View Application</button>
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <p>No applicants found.</p>
                            )}
                        </div>
                    )}
                </div>
            ))}

            {selectedJob && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center overflow-y-auto"
                    onClick={(e) => {
                        if (e.target === e.currentTarget) {
                            setSelectedJob(null);
                        }
                    }}
                >
                    <div className="bg-white p-4 rounded max-w-lg w-full m-4 overflow-y-auto max-h-[90vh]">
                        <h2 className="text-2xl font-bold mb-4">{selectedJob.title}</h2>
                        <p className="mb-2">
                            <strong>Description:</strong> {selectedJob.description}
                        </p>
                        <p className="mb-2">
                            <strong>Category:</strong> {selectedJob.category}
                        </p>
                        <p className="mb-2">
                            <strong>Location Type:</strong> {selectedJob.locationType}
                        </p>
                        {selectedJob.location && (
                            <p className="mb-2">
                                <strong>Location:</strong> {selectedJob.location}
                            </p>
                        )}
                        <p className="mb-2">
                            <strong>Experience Level:</strong> {selectedJob.experienceLevel}
                        </p>
                        <p className="mb-2">
                            <strong>Salary Range:</strong> {selectedJob.salaryRange}
                        </p>
                        <p className="mb-2">
                            <strong>Deadline:</strong> {new Date(selectedJob.deadline).toLocaleDateString()}
                        </p>
                        <p className="mb-2">
                            <strong>Department:</strong> {selectedJob.department}
                        </p>
                        <p className="mb-2">
                            <strong>Responsibilities:</strong> {selectedJob.responsibilities}
                        </p>
                        <p className="mb-2">
                            <strong>Requirements:</strong> {selectedJob.requirements}
                        </p>
                        <p className="mb-2">
                            <strong>Application Link:</strong>{' '}
                            <a
                                href={selectedJob.applicationLink}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {selectedJob.applicationLink}
                            </a>
                        </p>
                        <p className="mb-2">
                            <strong>Contact Email:</strong> {selectedJob.contactEmail}
                        </p>
                        <p className="mb-2">
                            <strong>Allow Sharing:</strong> {selectedJob.allowSharing ? 'Yes' : 'No'}
                        </p>

                        <h3 className="text-lg font-semibold mt-4 mb-2">Questions:</h3>
                        {selectedJob.questions.map((question) => (
                            <div key={question.id} className="mb-2">
                                <p>
                                    <strong>{question.question}</strong> ({question.type})
                                </p>
                                {question.options && question.options.length > 0 && (
                                    <ul className="list-disc list-inside">
                                        {question.options.map((option, index) => (
                                            <li key={index}>{option}</li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        ))}

                        <button
                            className="bg-gray-300 px-4 py-2 rounded mt-4"
                            onClick={() => setSelectedJob(null)}
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Jobs
